import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

const Field = ({type, name, placeholder, label, showError, defaultValue, onChange, value, index, maxLength}) => {
    const { errors, register, getValues } = useFormContext();

    const onFieldChange = () => {
        if (!onChange) {
            return;
        }
        onChange(getValues(name));
    }

    return (
        <div className="form__group">
            {label && type !== 'checkbox' && type !== 'radio' ? (
                <label className="form__label" htmlFor={name}>
                    {label}
                </label>
            ) : null}
            {type === 'textarea' ? (
                <textarea
                    className="form__field form__field--textarea"
                    type={type}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    ref={register}
                    maxLength={maxLength}
                    onChange={onFieldChange}
                    defaultValue={defaultValue ? defaultValue : ''}
                />
            ) : type === 'checkbox' ? (
                <>
                    <input
                        className="form__field form__field--checkbox"
                        type="checkbox"
                        name={name}
                        id={name}
                        placeholder={placeholder}
                        ref={register}
                        defaultChecked={defaultValue}
                        onChange={onFieldChange}
                    />
                    <label className="form__label form__label--checkbox" htmlFor={name}>
                        {label}
                    </label>
                </>
            ) : type === 'radio' ? (
                <>
                    <input
                        className="form__field form__field--radio"
                        type="radio"
                        name={name}
                        id={`${name}_${value}`}
                        ref={register}
                        value={value}
                        onChange={onFieldChange}
                        defaultChecked={index === 0}
                    />
                    <label className="form__label form__label--radio" htmlFor={`${name}_${value}`}>
                        {label}
                    </label>
                </>
            ) : (
                <input
                    className="form__field"
                    type={type}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    ref={register}
                    maxLength={maxLength}
                    onChange={onFieldChange}
                    defaultValue={defaultValue ? defaultValue : ''}
                />
            )}
            {showError && errors && errors[name] && errors[name].message ? (
                <div className="form__error">
                    {errors[name].message}
                </div>
            ) : null}
        </div>
    );
}

Field.defaultProps = {
    showError: true,
    defaultValue: false,
    subfield: false,
}

Field.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    showError: PropTypes.bool,
    defaultValue: PropTypes.any,
    onChange: PropTypes.any,
    value: PropTypes.string,
    index: PropTypes.number,
    subfield: PropTypes.bool,
}

export default Field;
